import { createBrowserRouter } from 'react-router-dom';
import Login from '../pages/login/Login';
import Home from '../pages/home/Home';
import LicitacionDetail from '../pages/details/LicitacionDetail';
import ComprasAgilesDetail from '../pages/compras-agiles-details/ComprasAgilesDetail';
import Alerts from '../pages/alerts/Alerts';
import User from '../pages/user/User';
import NotFound from '../pages/not-found/NotFound';
import MainLayout from '../layouts/MainLayout';
import ProtectedRoute from '../components/ProtectedRoute';
import ComprasAgiles from '../pages/compras-agiles/ComprasAgiles';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        element: <MainLayout />,
        children: [
          {
            path: '/',
            element: <Home />
          },
          {
            path: '/licitacion/:id',
            element: <LicitacionDetail />
          },
          {
            path: '/compras-agiles',
            element: <ComprasAgiles />
          },
          {
            path: '/compras-agiles/:id',
            element: <ComprasAgilesDetail />
          },
          {
            path: '/alerts',
            element: <Alerts />
          },
          {
            path: '/user',
            element: <User />
          }
        ]
      }
    ]
  },
  {
    path: '*',
    element: <NotFound />
  }
]); 